import React from 'react';

import MenuChatbot from './MenuChatBot';
import MenuVoicebot from './MenuVoicebot';

const ContextMenuPrimary = ({
  style,
  openSecondary,
  handleContextMenuOption,
  botType,
}) => {
  return (
    <>
      {botType === 'voice' ? (
        <MenuVoicebot style={style} handleItemClick={handleContextMenuOption} />
      ) : (
        <MenuChatbot style={style} openSecondary={openSecondary} />
      )}
    </>
  );
};

export default ContextMenuPrimary;
